import { Modal, closeModalByName, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { StyledSafeHtml, StyledActionBar, StyledButton, StyledT, StyledLink } from './DetailsModal.styles';
import { ContestResourceInfo } from '../ContestResource/ContestResource';
import { ContestInformation } from '../../../interfaces/ContestInformation';

export interface DetailsModalProps { }

const DetailsModal: FC<DetailsModalProps> = () => {
  const { t } = useTranslation('Contest');
  const dispatch = useDispatch();
  const contest: ContestInformation = useScopedSelector(ContestResourceInfo.dataDst);

  return (
    <Modal name="contestDetailsModal">
      <StyledT>{t('detailsModalTitle')}</StyledT>
      <StyledSafeHtml data-testid="detailsInformation">{contest?.description}</StyledSafeHtml>
      <StyledLink data-testid="detailsUri" href={contest?.contestRulesUri}>{t('contestRulesUriLabel')}</StyledLink>
      <StyledActionBar>
        <StyledButton data-testid="closeDetails" onClick={() => { dispatch(closeModalByName('contestDetailsModal')); }}>
          {t('detailsModalClose')}
        </StyledButton>
      </StyledActionBar>
    </Modal>
  );
};
export default DetailsModal;
